import FeatureFlagsHelper from '../classes/FeatureFlagsHelper';

export enum FEATURE_FLAGS {
    ALLOW_RESPONSIVE_FORMULAS = 'allow_responsive_formulas',
    TRIGGER_LOOKBACKS = 'trigger_lookbacks',
}

export type FeatureFlagConfig = Record<FEATURE_FLAGS, boolean>;

export interface WithFeatureFlagProps {
    featureFlags?: FeatureFlagsHelper;
}
